import React, { useState, useEffect } from 'react';

export default function TypewriterTitle({ lines, color1 = 'white', color2 = '#7aaef0' }) {
  const fullText = lines.join('\n');
  const [displayed, setDisplayed] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    let i = 0;
    setDisplayed('');
    setDone(false);
    const timer = setInterval(() => {
      if (i < fullText.length) {
        setDisplayed(fullText.slice(0, i + 1));
        i++;
      } else {
        setDone(true);
        clearInterval(timer);
      }
    }, 45);
    return () => clearInterval(timer);
  }, [fullText]);

  return (
    <h1 style={{
      fontFamily: "'Bebas Neue', sans-serif",
      fontSize: 'clamp(2rem, 6vw, 6rem)',
      color: color1, lineHeight: 0.95,
      letterSpacing: '0.02em', whiteSpace: 'pre-line',
    }}>
      {displayed.split('\n').map((line, i) => (
        <span key={i} style={{ display: 'block', color: i === 1 ? color2 : color1 }}>
          {line}
        </span>
      ))}
      {!done && (
        <span style={{
          display: 'inline-block', width: 3, height: '0.85em',
          background: color2, marginLeft: 4,
          animation: 'blink 0.7s step-end infinite',
          verticalAlign: 'middle',
        }} />
      )}
      <style>{`@keyframes blink { 0%,100%{opacity:1} 50%{opacity:0} }`}</style>
    </h1>
  );
}
